<template>
  <div id="top-header">
    <dv-decoration-8 class="header-left-decoration"/>
    <dv-decoration-5 class="header-center-decoration"/>
    <dv-decoration-8 class="header-right-decoration" :reverse="true"/>
    <div class="center-title">{{ title }}垃圾分类数据大屏</div>

    <div class="mh-right">
      <dv-border-box-2
        style="width: 120px; height: 50px; line-height: 50px; text-align:center;color: #fff;"
      >
        <a href="#/xunjian/record" style="color: #fff;">进入后台管理</a>
      </dv-border-box-2>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TopHeader',
  data() {
    return {
      title: ''
    }
  },
  methods: {
    getTitle() {
      let streetId = localStorage.getItem("streetId")
      if (!streetId) {
        streetId = JSON.parse(localStorage.getItem("USER")).streetId;
      }
      let params = {streetId: streetId};
      this.$get('/data/load_street_by_id', {
        ...params
      }).then((r) => {
        let data = r.data;
        if (data.code != 200) {
          this.$message.error("权限不足");
        } else {
          this.title = data.data.name;
        }
      })
    }
  },
  mounted() {
    const {getTitle} = this;
    getTitle();
  }
}
</script>

<style scoped lang="less">
#top-header {
  position: relative;
  width: 100%;
  height: 10%;
  display: flex;
  justify-content: space-between;
  flex-shrink: 0;

  .header-center-decoration {
    width: 40%;
    height: 60px;
    margin-top: 30px;
  }

  .header-left-decoration, .header-right-decoration {
    width: 25%;
    height: 60px;
  }

  .center-title {
    position: absolute;
    font-size: 30px;
    font-weight: bold;
    left: 50%;
    top: 15px;
    transform: translateX(-50%);
  }

  .mh-right {
    position: absolute;
    top: 15px;
    right: 2%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/datav/topHeader.vue